import { Component, Vue } from 'vue-property-decorator';
import { configYml } from '@/helpers/Environment';
import { getObjectPropertyByPath } from '@/helpers/MiscellaneousHelpers';
import { lowerFirst } from '@/helpers/StringHelpers';
import { notFoundRoute } from '@/errors/helpers';
import { languageItem } from '@/language/helpers';
import { flags } from '@/store/Flags';
/**
 * @see vue.d.ts
 */
@Component({ name: 'HelpersMixin' })
export default class extends Vue {
    // this just here so we can use `flags.xxx` in templates
    get flags() {
        return flags;
    }
    get opt() {
        if (this.key)
            return getObjectPropertyByPath(configYml.componentOptions ?? {}, this.key, {});
        else
            return {};
    }
    get t() {
        if (this.key)
            return languageItem(this.key);
        else
            return {};
    }
    get key() {
        // TODO Use component name with no transform once all components have type-safety for language strings.
        // @see LanguageStrings
        return this.$options.name ? lowerFirst(this.$options.name) : null;
    }
    $notFound() {
        return this.$router.replace(notFoundRoute(this.$route));
    }
}
